import { fromJS } from "immutable";

export const ListTemplateType = () => fromJS({
    1: { value:'text', label:'Text' },
    2: { value:'media', label:'Media' }
})

export const ListMediaType = () => fromJS({
    1: { value:'image', label:'Image' },
    2: { value:'document', label:'Document' },
})

export const ListMediaTypeHSM = () => fromJS({
    1: { value:'image', label:'Image' },
    2: { value:'document', label:'Document' },
    3: { value:'video', label:'Video' },
})

export const ListHeaderCardFormat = () => fromJS({
    1: { value:'image', label:'Image' },
    2: { value:'video', label:'Video' },
})

export const ListReportType = () => fromJS({
    1: { value:'IN', label:'IN' },
    2: { value:'OUT', label:'OUT' },
})

export  const  ListTemplateStatus = () => fromJS({
    1:{value : 0, label : 'New'},
    2:{value : 1, label : 'Approved'},
    3:{value : 2, label : 'Rejected'}
})